import React, {useState, useEffect, useContext} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartSimpleColumn from "../../components/AmChartSimpleColumn";
import CalendarIntensity from "../../components/CalendarIntensity";
import {COLOR_UTILISATION_OCCUPIED} from "../../constants/colors";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import ChartCardLarge from "../../components/ChartCardLarge";
import {store} from '../../context/store';

export default function UtilisationProfiles(){
	
	
	
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [calendarObject, setCalendarObject] = useState({});
	
	const [facilityId, setFacilityId] = useState("-100");
	
	const [loaded, setLoaded] = useState(false);
	
	const globalState = useContext(store);
			
		const utilisationSurveyId =
		    globalState?.state?.queryContext?.utilisationSurveyId ?? null;

	
	useEffect(() => {
		if(loaded === false){
			setLoaded(true);
		}
	
		loadData();
		
	}, [utilisationSurveyId]);
	
	const loadData = () => {
		loadData1();
		loadData2();
		loadData3();
	};
	
	const loadData1 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyhourwithfilter?utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	const loadData2 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbydayofweekwithfilter?utilisationSurveyId=" + utilisationSurveyId, setData2, handleData2);
	};
	
	const loadData3 = () => {
			functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetcalendarwithfilter?utilisationSurveyId=" + utilisationSurveyId, setCalendarObject, handleCalendarObject);
	}
	
	const handleData1 = (results) => {
	  const tempData = results.map(({label, avg }) => ({
	    id:label,
	    label,
	    value: avg,
	  }));
	  
	  setData1(tempData);
	};
	
	const handleData2 = (results) => {
	  const tempData = results.map(({label, avg }) => ({
	    id:label,
	    label:functions.getDayOfWeek(label),
	    value: avg,
	  }));
	  
	  setData2(tempData);
	};
	
	
	const handleCalendarObject = (object) => {
		setCalendarObject(object);
	}
  
	
	const refreshFunction = () => {
		loadData();
	};
 	
	return (
		
		<UtilityDashboardLayout
			    title="Utilisation Profiles"
			    childDashboards={childDashboardsUtilisation}
			    refreshFunction={refreshFunction}
			  >
			  <div style={utilityDashboardComponentContainer}>
				  <ChartCardLarge title="Weekly Profile">
					  <AmChartSimpleColumn
					 	chartId="utilisationprofilesweekly"
					 	chartData={data2}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_OCCUPIED}
					 	width="100%"
					 	height="calc(100% - 30px)"
						/>
		  		  </ChartCardLarge>
			</div>
			<div style={utilityDashboardComponentContainer}>
				  <ChartCardLarge title="Daily Profile">
					  <AmChartSimpleColumn
					 	chartId="utilisationprofilesdaily"
					 	chartData={data1}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_OCCUPIED}
					 	width="100%"
					 	height="calc(100% - 30px)"
						/>
		  		  </ChartCardLarge>
			  </div>
			  <CalendarIntensity
				calendarObject={calendarObject}
				/>
		</UtilityDashboardLayout>
	);
}